(function(){
  function init(root){
    var track = root.querySelector('[data-pg-track]');
    if(!track) return;
    var wrap = root.parentNode;
    var thumbs = wrap ? wrap.querySelector('[data-pg-thumbs]') : null;
    var items = track.children;

    function current(){
      var w = track.clientWidth;
      if(!w) return 0;
      return Math.round(track.scrollLeft / w);
    }
    function go(i){
      var n = items.length;
      if(i < 0) i = n - 1;
      if(i >= n) i = 0;
      var left = i * track.clientWidth;
      if(track.scrollTo){ track.scrollTo({left: left, behavior: 'smooth'}); }
      else { track.scrollLeft = left; }
    }
    function mark(){
      if(!thumbs) return;
      var i = current();
      var t = thumbs.children;
      for(var j = 0; j < t.length; j++){
        if(j === i){ t[j].classList.add('is-active'); } else { t[j].classList.remove('is-active'); }
      }
      var el = t[i];
      if(el){
        var min = el.offsetLeft - thumbs.clientWidth + el.offsetWidth + 8;
        var max = el.offsetLeft - 8;
        if(thumbs.scrollLeft > max) thumbs.scrollLeft = max;
        if(thumbs.scrollLeft < min) thumbs.scrollLeft = min;
      }
    }

    var prev = root.querySelector('[data-pg-prev]');
    var next = root.querySelector('[data-pg-next]');
    if(prev) prev.addEventListener('click', function(){ go(current() - 1); });
    if(next) next.addEventListener('click', function(){ go(current() + 1); });

    var timer;
    track.addEventListener('scroll', function(){
      clearTimeout(timer);
      timer = setTimeout(mark, 70);
    }, {passive: true});

    if(thumbs){
      for(var k = 0; k < thumbs.children.length; k++){
        (function(j){
          thumbs.children[j].addEventListener('click', function(){ go(j); });
        })(k);
      }
    }
    mark();
  }

  function boot(){
    var roots = document.querySelectorAll('[data-pg]');
    for(var i = 0; i < roots.length; i++){ init(roots[i]); }
  }
  if(document.readyState !== 'loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
